//import { Workbox } from "workbox-window";
//import OneSignal from 'OneSignal';
import OneSignal from 'react-onesignal';

export default function registerServiceWorker() {
  // if (process.env.NODE_ENV !== "production") {
  //   return;
  // }
  const oneSignalAppId = Env.ONE_SIGNAL_APP_ID;
  if ("serviceWorker" in navigator) {
    // Unregister any existing service workers
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    }).then(function() {
      // Register the new service worker
      navigator.serviceWorker.register('/serviceworker.js')
        .then(function(registration) {
          // Initialize OneSignal
          OneSignal.push(function() {
            OneSignal.SERVICE_WORKER_PATH = '/serviceworker.js';
            OneSignal.SERVICE_WORKER_PARAM = { scope: '/' };
            OneSignal.SERVICE_WORKER_UPDATER_PATH = '/serviceworker.js';
            OneSignal.init({
              appId: oneSignalAppId,
              serviceWorkerPath: '/serviceworker.js',
              allowLocalhostAsSecureOrigin: true,
              notifyButton: {
                enable: true,
              },
            });

            OneSignal.on('subscriptionChange', function(isSubscribed) {
              if (isSubscribed) {
                OneSignal.setExternalUserId(externalUserId);
              }
            });

            OneSignal.showSlidedownPrompt();
          });
        })
        .catch(function(err) {
          console.log('ServiceWorker registration failed: ', err);
        });
    });
  }
}
